export const CAPITAL_LETTER_REGEX = /[A-Z]/
export const SMALL_LETTERS_REGEX = /[a-z]/
export const AT_LEAST_ONE_NUMBER_REGEX = /\d/
export const SPECIAL_CHARACTERS_REGEX = /[!@#$%^&*()_+={}[\]|/;:',."<>?]/

export enum PasswordStrengthVariants {
  Weak = 'weak',
  Medium = 'medium',
  Strong = 'strong'
}

export const getPasswordStrength = (regexArray: RegExp[], value: string) => {
  const strength = regexArray.reduce((acc, regex) => {
    return regex.test(value) ? acc + 1 : acc
  }, 0)

  if (strength <= 2) return PasswordStrengthVariants.Weak
  if (strength <= 4) return PasswordStrengthVariants.Medium
  return PasswordStrengthVariants.Strong
}
